var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.$emit("input-click")
        }
      }
    },
    [
      _vm.vueTyperConfig && _vm.vueTyperConfig.text
        ? _c("vue-typer", _vm._b({}, "vue-typer", _vm.vueTyperConfig, false))
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }